import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  ListItemType,
  reward_item_type,
} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'

import {EggType, LotteryTime, Production} from './interface'

export enum RankTypeEnum {
  rank = 1,
  rule = 2,
}
export enum PageTypeEnum {
  monster = 0,
  rank,
}
export enum ModalTypeEnum {
  openBox = 1,
  getReward,
  rank20,
}
// 获取活动首页相关信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41439141
export const gashapon_machine_index = createAsyncThunk(
  'gashapon_machine_index',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'is_new'
          | 'free_times'
          | 'balance'
          | 'is_first'
          | 'cur_lucky_value'
          | 'total_lucky_value'
          | 'activity'
          | 'st'
          | 'et'
        >
      >
    >(
      '/live/activity/gashapon_machine_index',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 扭蛋操作 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41439069
export const gashapon_machine_lottery = createAsyncThunk(
  'gashapon_machine_lottery',
  async (arg: {type: EggType; num: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'free_times'
          | 'balance'
          | 'is_first'
          | 'status'
          | 'cur_lucky_value'
          | 'total_lucky_value'
          | 'products'
          | 'lucky_products'
          | 'err_msg'
        >
      >
    >(
      '/live/activity/gashapon_machine_lottery',

      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 任务列表 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41439301
export const gashapon_machine_missions = createAsyncThunk(
  'gashapon_machine_missions',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'score' | 'limit'>>
    >(
      '/live/activity/gashapon_machine_missions',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 任务完成领取奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41439321
export const gashapon_machine_missions_reawrd = createAsyncThunk(
  'gashapon_machine_missions_reawrd',
  async (arg: {mission_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{status: 0 | 1; err_msg: string}>>(
      '/live/activity/gashapon_machine_missions_reawrd',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        store,
      }
    )
    return resp.data.data
  }
)
// 扭蛋记录  https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41439238
export const gashapon_machine_record = createAsyncThunk(
  'gashapon_machine_record',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'messages'>>>(
      '/live/activity/gashapon_machine_record',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取播报数据 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90606364
export const gashapon_machine_report_message = createAsyncThunk(
  'gashapon_machine_report_message',
  async (arg: {type: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'messages' | 'type'>>
    >(
      '/live/activity/gashapon_machine_report_message',
      {
        ...arg, // type	int	0 播报 1幸运记录
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取扭蛋榜单 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41442508
export const gashapon_machine_rank = createAsyncThunk(
  'gashapon_machine_rank',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'list' | 'reward_list' | 'own' | 'count_down'>
      >
    >(
      '/live/activity/gashapon_machine_rank',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface activity_item {
  type: EggType
  text: string
  lottery_times: Array<LotteryTime>
  products: Array<Production>
  lucky_products: Array<Production>
  lucky_gift: Array<giftItem>
}
export enum missionStatusEnum {
  去完成 = 0,
  已领取,
  可领取,
}
interface mission_item {
  mission_id: number
  reward: string
  // 0 去完成1 已领取 2 可领取
  status: missionStatusEnum
  desc: string
  target: number
  current: number
}
interface record_item extends Production {
  created_at: string
}

interface giftItem {
  desc: string
  icon: string
}
export interface message_item extends Production {
  mid: number
  avatar: string
  name: string
}

interface InitialStateType {
  free_times?: number
  balance?: number
  is_first?: boolean
  activity?: Array<activity_item>
  // 抽奖
  // 1 成功 2钱不够
  status?: 1 | 2
  cur_lucky_value?: number
  total_lucky_value?: number
  products?: Array<Production>
  lucky_products?: Array<Production>
  missions?: Array<mission_item>
  // 任务2.0 改版 改成充值获取免费银弹
  score?: number
  limit?: number
  records?: Array<record_item>
  messages?: Array<message_item>
  // 扭蛋机 3.0
  luck_message?: Array<message_item>
  type?: number
  is_new?: boolean // 新版
  //
  // 榜单
  list?: Array<ListItemType>
  own?: ListItemType
  count_down?: number
  // 奖励
  reward_list?: Array<reward_item_type>
  err_msg?: string
  st?: string
  et?: string
}

const initialState: InitialStateType = {}

export const Animal_OtterSlice = createSlice({
  name: 'Animal_Otter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 主页
    builder.addCase(gashapon_machine_index.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(gashapon_machine_lottery.fulfilled, (state, action) => {
      const {
        balance,
        free_times,
        is_first,
        cur_lucky_value,
        total_lucky_value,
      } = action.payload
      Object.assign(state, {
        balance,
        free_times,
        is_first,
        cur_lucky_value,
        total_lucky_value,
      })
    })
    builder.addCase(gashapon_machine_missions.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(gashapon_machine_record.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    // 榜单和榜单奖励
    builder.addCase(gashapon_machine_rank.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(
      gashapon_machine_report_message.fulfilled,
      (state, action) => {
        const {type, messages} = action.payload
        if (type === 0) {
          // 播报
          Object.assign(state, {messages})
        } else {
          Object.assign(state, {luck_message: messages})
        }
      }
    )
  },
})
export default Animal_OtterSlice.reducer
export const Animal_OtterActions = Animal_OtterSlice.actions
